import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BalkonForm } from '.';
import useGlobal from '../../../store';
import Button from '../../components/button';
import SillSettingsForm from '../../components/sill.settings';
import WindowsConstructor from '../../components/windows.constructor';
import WindowsSettings from '../../components/windows.settings';
import WindowsToSuppliers from '../../components/windows.to.suppliers';
import WindowsInnerConstructor from '../../components/windows.inner.constructor';
import WindowsInnerSettings from '../../components/windows.inner.settings';

const BalkonWindows = () => {
  
  const [ globalState, globalActions ] = useGlobal();
  const { balkon } = globalActions;

  const [ isPartnersOpened, setIsPartnersOpened ] = useState( false );

  const navigate = useNavigate();

  useEffect(() => { document.getElementById('scrollTop').scrollIntoView() }, []);

  return (

    <BalkonForm step = { 3 }>

      <WindowsToSuppliers

        opened = { isPartnersOpened } 
        close = { () => setIsPartnersOpened( false ) }

      />
      
      <div id = "scrollTop" className="balkon_settings__title text-center">Окна:</div>
      <WindowsConstructor />
      <WindowsSettings />

      <div className = "balkon_settings__title text-center">Внутренние окна:</div>
      <WindowsInnerConstructor />
      <WindowsInnerSettings />

      <div className="balkon_settings__title text-center">Подоконник:</div>
      <SillSettingsForm disableColorSelector />

      <Button

        text = "Отправить на оценку"
        action = { () => { balkon.save( () => setIsPartnersOpened( true ), false ) }}

      />

      <hr className="small" />

      <Button

        color = "yellow"
        text = "Пропустить этот шаг"
        action = { () => { balkon.save( () => navigate('/constructor'), false ) }}

      />

      <Button

        text = "Далее"
        action = { () => { balkon.save( () => navigate('/constructor'), false ) }}

      />
    
    </BalkonForm>

  );

}

export default BalkonWindows;